import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { ReactNode } from 'react'
import { CustomerHandoffSummary } from './CustomerHandoffSummary'

interface CustomerHandoffDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  manualTotal: number
  electronicTotal: number
  confirmLabel: string
  onConfirm: () => void
  isPending?: boolean
  /** The handoff can't be confirmed yet, such as while its till is still being read. */
  confirmDisabled?: boolean
  /** The till the cash comes from, when Cash Drawer tracking needs one. */
  till?: ReactNode
  /** Choices shown above the handoff, such as whether the customer gets the receipt. */
  children?: ReactNode
}

/** The refund flow's customer handoff confirmation, for any return that hands back cash or a check. */
export function CustomerHandoffDialog({
  open,
  onOpenChange,
  manualTotal,
  electronicTotal,
  confirmLabel,
  onConfirm,
  isPending = false,
  confirmDisabled = false,
  till,
  children,
}: CustomerHandoffDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Customer Handoff</DialogTitle>
          <DialogDescription>
            Confirm the refund amount has been handed back to the customer before submitting this
            refund.
          </DialogDescription>
        </DialogHeader>
        {children}
        <CustomerHandoffSummary manualTotal={manualTotal} electronicTotal={electronicTotal}>
          {till}
        </CustomerHandoffSummary>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            disabled={isPending}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button type="button" disabled={isPending || confirmDisabled} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
